import { ITEMS_GAP, SHOW_MORE_WIDTH } from './constants';

export const getHiddenItemsCount = (
  elemRight: number,
  listRight: number,
  currentCount: number,
) => {
  let localCount = currentCount;
  if (elemRight > listRight) {
    localCount++;
  } else {
    if (localCount > 0) {
      if (elemRight > listRight - (SHOW_MORE_WIDTH + ITEMS_GAP)) {
        localCount++;
      }
    }
  }
  return localCount;
};
